import React from "react";
import { Truck } from "lucide-react";
import dict from "../i18n/es-MX";

export const BrandMark = ({ size = 40, className = "" }) => (
    <div
        data-testid="brand-mark"
        className={`flex items-center justify-center rounded-lg bg-brand-orange shadow-[0_4px_0_rgba(0,0,0,0.25)] ${className}`}
        style={{ width: size, height: size }}
    >
        <Truck size={Math.round(size * 0.55)} strokeWidth={2.5} className="text-white" />
    </div>
);

export const BrandLockup = ({ size = 40, showTagline = false, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-lockup">
        <BrandMark size={size} />
        <div className="leading-tight">
            <div
                className="font-display text-2xl font-extrabold tracking-tight text-slate-50"
                data-testid="brand-name"
            >
                {dict.brand.name}
            </div>
            {showTagline && (
                <div className="text-xs uppercase tracking-[0.18em] text-slate-400">
                    {dict.brand.tagline}
                </div>
            )}
        </div>
    </div>
);
